import { Container, Graphics, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { MyWalletResourcePackage } from "../resources/MyWalletResourcePackage";

export class BuildingAddress extends Container {
    private addressPlaceholderBackground: Graphics;
    private addressPlaceholder: Sprite;
    private address: Text;

    public constructor(myWalletResources: MyWalletResourcePackage) {
        super();
        this.addressPlaceholderBackground = new Graphics();
        this.addressPlaceholderBackground.beginFill(0xffffff);
        this.addressPlaceholderBackground.drawRect(0, 0, 236, 63);
        this.addressPlaceholderBackground.endFill();

        this.addressPlaceholder = new Sprite(myWalletResources.assets_views_my_wallet_ui_adress_placeholder_png);
        this.addressPlaceholder.position.set(0, this.addressPlaceholderBackground.height * 0.5 - this.addressPlaceholder.height * 0.5);

        this.address = new Text('37 W 11 ST', new StreetTextStyle());
        this.address.anchor.y = 0.5;
        this.address.position.set(15, this.addressPlaceholder.height * 0.5);
        this.addressPlaceholder.addChild(this.address);

        this.addressPlaceholderBackground.addChild(this.addressPlaceholder);
        this.addChild(this.addressPlaceholderBackground);
    }

    public updateAddress(address: string): void {
        this.address.text = address;
        this.adjustText();
        this.address.position.x = (this.addressPlaceholder.width - this.address.width) * 0.5;
    }

    private adjustText(): void {
        if (this.address.width + 24 >= this.addressPlaceholder.width * 0.9) {
            this.address.scale.set(this.addressPlaceholder.width * 0.85 / (this.address.width + 24));
        }
    }

}

class StreetTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 48,
            trim: true
        }));
    }
}
